import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ProgressBar from '../progress-bar';
import { requestOpportunityOwnerSignature, requestAccountOwnerSignature } from './actions';
import { getOpportunityOwnerSignature } from './reducer';
import RequestUserEmailSignature from './RequireUserEmailSignature';
import { getUser } from '../../modules/Auth/AuthReducer';

class RequiredOpportunityOwnerSignature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      object: props.object,
    };
  }

  componentDidMount() {
    if (this.props.initiative && this.props.object && !this.props.loaded && !this.props.loading) {
      const id = this.props.isAccount ? this.props.object.account_id : this.props.object.opportunity_id;
      const action = this.props.isAccount ? requestAccountOwnerSignature : requestOpportunityOwnerSignature;
      const collectorId = this.props.initiative.defaultCollector?.collector_id;
      this.props.dispatch(action(this.props.initiative.client_id, this.props.initiative.id, id, collectorId));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.object) {
      const currentObject = this.props.object || {};
      if (nextProps.initiative.id !== this.props.initiative.id ||
        nextProps.initiative.client_id !== this.props.initiative.client_id ||
        currentObject._id !== nextProps.object._id) {
        const id = nextProps.isAccount ? nextProps.object.account_id : nextProps.object.opportunity_id;
        const action = nextProps.isAccount ? requestAccountOwnerSignature : requestOpportunityOwnerSignature;
        const collectorId = this.props.initiative.defaultCollector?.collector_id;
        this.props.dispatch(action(nextProps.initiative.client_id, nextProps.initiative.id, id, collectorId));
      }
    }
    if (nextProps.object) {
      this.setState({ object: nextProps.object });
    }
  }

  renderMissingOppotunity() {
    const { isAccount } = this.props;
    const type = isAccount ? 'account' : 'opportunity';
    return (
      <div className="alert alert-danger">
        Missing {type} info.
      </div>
    );
  }

  renderLoading() {
    const { isAccount } = this.props;
    const type = isAccount ? 'account' : 'opportunity';
    return (
      <div className="well">
        <p />
        <p>Required {type} owner signature</p>
        <ProgressBar />
        <p />
      </div>
    );
  }

  render() {
    const {
      children, loading, loaded,
      onCancel, isOwner,
      isSFOpportunityOwner,
    } = this.props;
    const { object } = this.state;
    if (!object) {
      return this.renderMissingOppotunity();
    }
    const displaySpinner = loading || !loaded;
    if (displaySpinner) {
      return this.renderLoading();
    }
    // if this is an owner, always requires his signature
    // if he's not an owner, we can let him use the SC email or any of the available email from TV 
    if (isSFOpportunityOwner || isOwner) {
      return (
        <RequestUserEmailSignature onCancel={onCancel}>{children}</RequestUserEmailSignature>
      );
    }
    return children;
  }
}

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  let info = {};
  let isSFOpportunityOwner = false;
  const auth = getUser(state);
  if (ownProps.object && ownProps.initiative) {
    const id = ownProps.isAccount ? ownProps.object.account_id : ownProps.object.opportunity_id;
    const collectorId = ownProps.initiative.defaultCollector?.collector_id;
    info = getOpportunityOwnerSignature(state, ownProps.initiative.client_id, ownProps.initiative.id, id, collectorId);
  }
  if (ownProps.opportunity && ownProps.opportunity.owner && auth) {
    isSFOpportunityOwner = ownProps.opportunity.owner.user_id === auth.user_id;
  }
  return {
    loaded: info.status === 'loaded',
    loading: info.status === 'loading',
    verified: info.signature === 'verified',
    isOwner: info.isOwner,
    isSFOpportunityOwner,
  };
}

RequiredOpportunityOwnerSignature.propTypes = {
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.node,
  object: PropTypes.shape({
    _id: PropTypes.string,
    opportunity_id: PropTypes.string,
    account_id: PropTypes.string,
  }),
  isAccount: PropTypes.bool,
  initiative: PropTypes.shape({
    id: PropTypes.string,
    client_id: PropTypes.string,
    defaultCollector: PropTypes.shape({
      collector_id: PropTypes.string,
    }),
  }).isRequired,
  isOwner: PropTypes.bool,
  isSFOpportunityOwner: PropTypes.bool,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  verified: PropTypes.bool,
  onCancel: PropTypes.func,
};
RequiredOpportunityOwnerSignature.defaultProps = {
  children: null,
  object: null,
  isAccount: false,
  loading: false,
  loaded: false,
  isOwner: false,
  isSFOpportunityOwner: false,
  onCancel: null,
  verified: false,
};


export default connect(mapStateToProps)(RequiredOpportunityOwnerSignature);
